import { Button } from "@mui/material";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import { MvButtonPropsInterface } from "@mv-components/types";

const CustomButton = (props: MvButtonPropsInterface) => {
	const {
		disabled,
		primary,
		secondary,
		textButton,
		className,
		onClick,
		variant = "",
		size = "",
		children,
		startIcon,
	} = props;

	const { classes, cx } = useStyles(styles) as any;

	return (
		<Button
			disabled={disabled}
			onClick={(event: React.MouseEvent) => onClick(event)}
			color="primary"
			variant={secondary ? "outlined" : textButton ?? primary ? "text" : "contained"}
			className={cx(
				classes[variant],
				className,
				size && classes[size],
				{ [classes.buttonSecondary]: secondary, [classes.buttonSecondaryDisable]: secondary && disabled },
				{ [classes.textTypeButton]: textButton },
				{ [classes.buttonPrimary]: primary },
				{ [classes.button]: !secondary && !textButton && !primary }
			)}
			startIcon={startIcon}
		>
			{children}
		</Button>
	);
};

export default CustomButton;
